export default __webpack_public_path__ + "static/media/strech-yarn-plp.72903715.png";